import OrderServeType from '@/constants/OrderServeType';
import { isEmpty } from 'lodash';

const isPostPay = (webStoreVo, serveType): boolean => {
  const isPostPayEnable: boolean =
    webStoreVo.isPostPayEnable && serveType === OrderServeType.DINE_IN;
  return isPostPayEnable;
};

const checkPhoneRequired = (
  webStoreVo,
  serveType,
  selectedTakeOutServeType
) => {
  if (isEmpty(webStoreVo)) return false;
  const {
    webUiConfig: { enableInputPhone, enableTakeoutPhone },
  } = webStoreVo || {};
  if (isPostPay(webStoreVo, serveType)) return true;
  if (serveType === OrderServeType.DINE_IN && enableInputPhone) {
    return true;
  }
  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.TAKE_OUT &&
    enableTakeoutPhone
  ) {
    return true;
  }
  if (
    serveType === OrderServeType.TAKE_OUT &&
    selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT
  ) {
    return true;
  }

  if (serveType === OrderServeType.DELIVERY) {
    return true;
  }
  return false;
};

export default checkPhoneRequired;
